module.exports = __webpack_public_path__ + "static/media/impressions.dec0800b.svg";